import { render, staticRenderFns } from "./appModal.vue?vue&type=template&id=606876c7&"
import script from "./appModal.vue?vue&type=script&lang=js&"
export * from "./appModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports